/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateUserAddress201ResponseAllOfData } from './CreateUserAddress201ResponseAllOfData';
import {
    CreateUserAddress201ResponseAllOfDataFromJSON,
    CreateUserAddress201ResponseAllOfDataFromJSONTyped,
    CreateUserAddress201ResponseAllOfDataToJSON,
} from './CreateUserAddress201ResponseAllOfData';

/**
 * 
 * @export
 * @interface CreateUserAddress201Response
 */
export interface CreateUserAddress201Response {
    /**
     * 
     * @type {CreateUserAddress201ResponseAllOfData}
     * @memberof CreateUserAddress201Response
     */
    data: CreateUserAddress201ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof CreateUserAddress201Response
     */
    meta: object;
}

/**
 * Check if a given object implements the CreateUserAddress201Response interface.
 */
export function instanceOfCreateUserAddress201Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function CreateUserAddress201ResponseFromJSON(json: any): CreateUserAddress201Response {
    return CreateUserAddress201ResponseFromJSONTyped(json, false);
}

export function CreateUserAddress201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserAddress201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': CreateUserAddress201ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function CreateUserAddress201ResponseToJSON(value?: CreateUserAddress201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateUserAddress201ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

